// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\">Account Authorizations</h1> <p>To ensure the privacy of our customers, we will not release account specific information to anyone other than the borrower, a co-signer, endorser, or an authorized third party.</p> <p>Check out the different types of third-party contacts.</p> ";
// Exports
export default code;